import React from "react";
import { StandardSelectOption } from "../../../selector/parts/SelectOption";
import {
  SingleSelector,
  SingleSelectProps,
} from "../../../selector/SingleSelector";

type PageSizeSelectorProps = {
  value: number;
  onChange: (pageSize: number) => void;
} & Omit<
  SingleSelectProps<string>,
  "options" | "placeholder" | "value" | "onChange" | "enableDeselect"
>;

export function PageSizeSelector({
  value,
  onChange,
  ...props
}: PageSizeSelectorProps): React.ReactElement {
  return (
    <SingleSelector
      enableDeselect={false}
      value={value.toString()}
      onChange={(selection) => onChange(parseInt(selection))}
      placeholder="Transactions per page"
      options={PageSizeSelectorOptions}
      {...props}
    />
  );
}

export const PageSizeOptions = [10, 20, 50, 100];

const PageSizeSelectorOptions: StandardSelectOption[] = PageSizeOptions.map(
  (value) => ({
    value: value.toString(),
    data: {
      label: `Show ${value} items`,
    },
  }),
);
